import Vue from "vue"
import Router from "vue-router"
import elderManage from "./utils/elderManage" //适老化路由
import elderlyService from "./utils/elderlyService" //养老服务
import callCenter from "./utils/callCenter" //呼叫中心
import store from "./store"
// 解决vue路由导航报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/oldManStatistics",
      name: "oldManStatistics",
      component: () =>
        // 以前对应的组件
        // import ('./views/platform/provideManage/oldManStatistics.vue')

        // 机构养老一张图对应组件
        import("./views/platform/InstitutionalOldmanImg/index.vue"),
    },
    elderManage,
    elderlyService,
    callCenter,
    // 呼叫中心可视化
    {
      path: "/oldBigData",
      name: "oldBigData",
      component: () => import("./views/callCenter/bigdatas/bigdata"),
    },
    //社区助餐系统
    {
      path: "/orderFood",
      name: "orderFood",
      component: () => import("./components/orderFood/container.vue"),
      children: [
        // 首页
        {
          path: "/orderFoodIndex",
          name: "orderFoodIndex",
          component: () => import("./components/orderFood/index.vue"),
        },
        // 用户管理
        {
          path: "/userManage",
          name: "userManage",
          component: () =>
            import("./components/orderFood/userManage/index.vue"),
        },
        // 水心亭
        {
          path: "/shuiManage",
          name: "shuiManage",
          component: () =>
            import("./components/orderFood/shuiManage/index.vue"),
        },
        // 水心亭用户调查
        {
          path: "/shuiInvestigate",
          name: "shuiInvestigate",
          component: () =>
            import("./components/orderFood/shuiInvestigate/index.vue"),
        },
        // 消费记录
        {
          path: "/consumption",
          name: "consumption",
          component: () =>
            import("./components/orderFood/consumption/index.vue"),
        },
        // 订餐管理
        {
          path: "/foodManage",
          name: "foodManage",
          component: () =>
            import("./components/orderFood/orderManage/foodManage.vue"),
        },
        // 支付管理首页
        {
          path: "/paymentIndex",
          name: "paymentIndex",
          component: () => import("./components/orderFood/payment/index.vue"),
        },
        // 支付信息
        {
          path: "/paymentInfo",
          name: "paymentInfo",
          component: () =>
            import("./components/orderFood/payment/paymentInformation.vue"),
        },
        // 人员管理
        {
          path: "/peopleManage",
          name: "peopleManage",
          component: () => import("./components/orderFood/peopleManage.vue"),
        },
        // 菜品信息
        {
          path: "/information",
          name: "varietydishesinformation",
          component: () =>
            import("./components/orderFood/varietydishes/information.vue"),
        },
        // 每周菜单
        {
          path: "/menuWeekly",
          name: "varietydishesmenu",
          component: () =>
            import("./components/orderFood/varietydishes/menuWeekly.vue"),
        },
        // 原料维护
        {
          path: "/material",
          name: "orderFoodmaterial",
          component: () =>
            import("./components/orderFood/basicData/material.vue"),
        },
        // 固定资产
        {
          path: "/equipment",
          name: "orderFoodequipment",
          component: () =>
            import("./components/orderFood/basicData/equipment.vue"),
        },
        // 餐补等级
        {
          path: "/foodSupplement",
          name: "orderFoodfood",
          component: () =>
            import("./components/orderFood/basicData/foodSupplement.vue"),
        },
        {
          path: "/foodPolicy",
          name: "foodPolicy",
          mate: {
            title: "助餐政策",
          },
          component: () =>
            import("./components/orderFood/basicData/foodPolicy.vue"),
        },
        {
          path: "/foodPrice",
          name: "foodPrice",
          mate: {
            title: "菜单价格",
          },
          component: () =>
            import("./components/orderFood/basicData/foodPrice.vue"),
        },
        {
          path: "/serviceStyle",
          name: "serviceStyle",
          mate: {
            title: "菜单价格",
          },
          component: () =>
            import("./components/orderFood/basicData/serviceStyle.vue"),
        },
      ],
    },

    //走访探视
    {
      path: "/visitContainer",
      name: "visitContainer",
      component: () => import("./components/visit/container.vue"),
      children: [
        // 首页
        {
          path: "/visitIndex",
          name: "visitIndex",
          component: () => import("./components/visit/index.vue"),
        },
        // 老人管理
        {
          path: "/oldAdministration",
          name: "oldAdministration",
          component: () =>
            import("./components/visit/oldAdministration/oldIndex.vue"),
        },
        // 走访清单
        {
          path: "/visitList",
          name: "visitList",
          component: () => import("./components/visit/visitList/listIndex.vue"),
        },
        // 走访类型设置
        {
          path: "/visitType",
          name: "visitType",
          component: () => import("./components/visit/visitType/typeIndex.vue"),
        },
        // 服务人员管理
        {
          path: "/servicePeople",
          name: "servicePeople",
          component: () => import("./components/visit/peopleManage.vue"),
          mate: {
            title: "服务人员管理",
          },
        },
        // 信息服务工单
        {
          path: "/infoserviceWorder",
          name: "infoserviceWorder",
          component: () =>
            import("./components/visit/infoserviceWorder/infoIndex.vue"),
          mate: {
            title: "信息服务工单",
          },
        },
      ],
    },
    // 监管可视化平台可视化
    {
      path: "/Supervisoryvisualization",
      name: "Supervisoryvisualization",
      component: () => import("./views/Supervisoryvisualization/main.vue"),
      children: [
        // 监管可视化
        {
          path: "/supVisit",
          name: "supVisit",
          component: () =>
            import("./views/Supervisoryvisualization/supVisit/index.vue"),
        },
      ],
    },
    //养老一张图
    {
      path: "/bigDataPlatform",
      name: "bigDataPlatform",
      mate: {
        title: "养老一张图",
      },
      component: () => import("./views/bigDataPlatform/index"),
    },
    // 养老可视化
    {
      path: "/visualization",
      name: "visualization",
      component: () => import("./views/visualization/main.vue"),
      children: [
        // 适老化
        {
          path: "/olderman",
          name: "olderman",
          component: () => import("./views/visualization/olderman/index.vue"),
        },
        // 走访探视
        {
          path: "/visit",
          name: "visit",
          component: () => import("./views/visualization/visit/index.vue"),
        },
        // 时间银行
        {
          path: "/date",
          name: "date",
          component: () => import("./views/visualization/date/index.vue"),
        },
        // 床位管理
        {
          path: "/bedManage",
          name: "bedManage",
          component: () => import("./views/visualization/bedManage/index.vue"),
        },
        {
          path: "/mealAid",
          name: "mealAid",
          component: () => import("./views/visualization/mealAid/index.vue"),
        },
      ],
    },
    //残联可视化
    {
      path: "/eldlyIndex",
      name: "eldlyIndex",
      mate: {
        title: "残联首页",
      },
      component: () => import("./views/homeCare/eldlyHome/index"),
    },
    {
      path: "/federHome",
      name: "federHome",
      mate: {
        title: "残联居家",
      },
      component: () => import("./views/homeCare/federHome/index"),
    }, {
      path: "/affairHome",
      name: "affairHome",
      mate: {
        title: "民政居家",
      },
      component: () => import("./views/homeCare/affairHome/index"),
    },
    {
      path: "/disabledHome",
      name: "disabledHome",
      mate: {
        title: "残联人之家",
      },
      component: () => import("./views/homeCare/disabledHome/index"),
    },
    {
      path: "/childCareCenter",
      name: "childCareCenter",
      mate: {
        title: "托养中心",
      },
      component: () => import("./views/homeCare/childCareCenter/index"),
    },
    // 黄冈
    {
      path: "/home",
      name: "home",
      meta: {
        index: 1,
      },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/hgVisit/home.vue"),
      redirect: "/hgVisit",
      children: [
        {
          path: "/hgVisit",
          name: "hgVisit",
          meta: {
            index: 1,
          },
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/hgVisit/index.vue"),
        },
        {
          path: "/hgVisit1",
          name: "hgVisit1",
          meta: {
            index: 2,
          },
          component: () =>
            import(
              /* webpackChunkName: "about" */ "./views/hgVisit/hgVisits.vue"
            ),
        },
        {
          path: "/hgVisit2",
          name: "hgVisit2",
          meta: {
            index: 3,
          },
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/hgVisit/three.vue"),
        },
      ],
    },
    //来安
    {
      path: "/home",
      name: "home",
      meta: {
        index: 1,
      },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/laVisit/home.vue"),
      redirect: "/laVisit",
      children: [
        {
          path: "/laVisit",
          name: "laVisit",
          meta: {
            index: 1,
          },
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/laVisit/index.vue"),
        },
        {
          path: "/laVisit1",
          name: "laVisit1",
          meta: {
            index: 2,
          },
          component: () =>
            import(
              /* webpackChunkName: "about" */ "./views/laVisit/hgVisits.vue"
            ),
        },
        {
          path: "/laVisit2",
          name: "laVisit2",
          meta: {
            index: 3,
          },
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/laVisit/three.vue"),
        },
      ],
    },
    //智能监控
    {
      path: "/znjk",
      name: "znjk",
      meta: {
        index: 1,
      },
      component: () => import("./views/znjk/znjk.vue"),
      redirect: "/znjk",
      // children: [
      //     {
      //         path: '/znjk',
      //         name: 'znjk',
      //         meta: {
      //             index: 1
      //         },
      //         component: () => import ('./views/znjk/znjk.vue'),

      //     }
      // ]
    },
    //街道一张图
    {
      path: "/streetMap",
      name: "streetMap",
      meta: {
        index: 1,
      },
      component: () => import("./views/streetMap/streetMap.vue"),
    },

    // 系统设置
    {
      path: "/system",
      name: "system",
      meta: {
        index: 5,
      },
      component: () => import("./views/system.vue"),
      redirect: "/organization",
      children: [
        // 组织机构管理
        {
          path: "/organization",
          name: "organization",
          meta: {
            index: 51,
          },
          component: () => import("@/views/callCenter/main"),
          // import ('./views/system/organization.vue'),
          redirect: "/organizationIndex",
          children: [
            {
              path: "/customerInfo",
              name: "customerInfo",
              mate: {
                title: "工作台",
              },
              component: () => import("@/views/callCenter/customerInfo/index"),
            },
            {
              path: "/infoStatics",
              name: "infoStatics",
              mate: {
                title: "站点数据查看",
              },
              component: () => import("./views/infoStatics/index"),
            },
            {
              path: "/servicePersonnel",
              name: "servicePersonnel",
              mate: {
                title: "服务人员分布",
              },
              component: () =>
                import("@/views/callCenter/mapDisplay/servicePersonnel.vue"),
            },
            {
              path: "/serviceGroup",
              name: "serviceGroup",
              mate: {
                title: "机构分布",
              },
              component: () =>
                import("@/views/callCenter/mapDisplay/serviceGroup.vue"),
            },
            {
              path: "/serviceObject",
              name: "serviceObject",
              mate: {
                title: "服务对象分布",
              },
              component: () =>
                import("@/views/callCenter/mapDisplay/serviceObject.vue"),
            },
            {
              path: "/townShip",
              name: "townShip",
              mate: {
                title: "乡镇服务",
              },
              component: () =>
                import("@/views/callCenter/mapDisplay/townShip.vue"),
            },
            {
              path: "/servicePersonnel",
              name: "servicePersonnel",
              mate: {
                title: "服务人员分布",
              },
              component: () =>
                import("@/views/callCenter/mapDisplay/servicePersonnel.vue"),
            },
            {
              path: "/detailsInfo",
              name: "detailsInfo",
              mate: {
                title: "工单系统",
              },
              component: () => import("@/views/callCenter/detailsInfo/index"),
              children: [
                {
                  path: "/serviceOrder",
                  name: "serviceOrder",
                  mate: {
                    title: "服务工单",
                  },
                  component: () =>
                    import("@/views/callCenter/detailsInfo/serviceOrder/index"),
                },
                {
                  path: "/returnVisit",
                  name: "returnVisit",
                  mate: {
                    title: "老干服务工单",
                  },
                  component: () =>
                    import("@/views/callCenter/detailsInfo/returnVisit/index"),
                  children: [
                    {
                      path: "/workOrder1",
                      name: "workOrder1",
                      mate: {
                        title: "老干工单派发",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/returnVisit/workOrder1"
                        ),
                    },
                    {
                      path: "/workOrder2",
                      name: "workOrder2",
                      mate: {
                        title: "老干工单处理",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/returnVisit/workOrder2"
                        ),
                    },
                    {
                      path: "/workOrder3",
                      name: "workOrder3",
                      mate: {
                        title: "老干工单回访",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/returnVisit/workOrder3"
                        ),
                    },
                    {
                      path: "/workOrder4",
                      name: "workOrder4",
                      mate: {
                        title: "老干工单作废",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/returnVisit/workOrder4"
                        ),
                    },
                    {
                      path: "/workOrder5",
                      name: "workOrder5",
                      mate: {
                        title: "老干工单完成",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/returnVisit/workOrder5"
                        ),
                    },
                    {
                      path: "/workOrder6",
                      name: "workOrder6",
                      mate: {
                        title: "老干工单已作废",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/returnVisit/workOrder6"
                        ),
                    },
                    {
                      path: "/workOrder7",
                      name: "workOrder7",
                      mate: {
                        title: "老干工单查询",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/returnVisit/workOrder7"
                        ),
                    },
                  ],
                },
                {
                  path: "/workEdit",
                  name: "workEdit",
                  mate: {
                    title: "工单编辑",
                  },
                  component: () =>
                    import("@/views/callCenter/detailsInfo/workEdit/index"),
                },
                {
                  path: "/workQuery",
                  name: "workQuery",
                  mate: {
                    title: "工单查询",
                  },
                  component: () =>
                    import("@/views/callCenter/detailsInfo/workQuery/index"),
                },
                {
                  path: "/addReturn",
                  name: "addReturn",
                  mate: {
                    title: "民政服务工单",
                  },
                  component: () =>
                    import("@/views/callCenter/detailsInfo/addReturn/index"),
                  children: [
                    {
                      path: "/civilOrder1",
                      name: "civilOrder1",
                      mate: {
                        title: "民政工单派发",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/addReturn/civilOrder1"
                        ),
                    },
                    {
                      path: "/civilOrder2",
                      name: "civilOrder2",
                      mate: {
                        title: "民政工单处理",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/addReturn/civilOrder2"
                        ),
                    },
                    {
                      path: "/civilOrder3",
                      name: "civilOrder3",
                      mate: {
                        title: "民政工单回访",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/addReturn/civilOrder3"
                        ),
                    },
                    {
                      path: "/civilOrder4",
                      name: "civilOrder4",
                      mate: {
                        title: "民政工单待作废",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/addReturn/civilOrder4"
                        ),
                    },
                    {
                      path: "/civilOrder5",
                      name: "civilOrder5",
                      mate: {
                        title: "民政工单已完成",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/addReturn/civilOrder5"
                        ),
                    },
                    {
                      path: "/civilOrder6",
                      name: "civilOrder6",
                      mate: {
                        title: "民政工单已作废",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/addReturn/civilOrder6"
                        ),
                    },
                    {
                      path: "/civilOrder7",
                      name: "civilOrder7",
                      mate: {
                        title: "民政工单统计",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/addReturn/civilOrder7"
                        ),
                    },
                    {
                      path: "/civilOrder8",
                      name: "civilOrder8",
                      mate: {
                        title: "民政工单查询",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/addReturn/civilOrder8"
                        ),
                    },
                    {
                      path: "/civilOrder9/:type",
                      name: "civilOrder9",
                      mate: {
                        title: "异常工单",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/addReturn/civilOrder9"
                        ),
                    },
                  ],
                },
                {
                  path: "/canlianReturn",
                  name: "canlianReturn",
                  mate: {
                    title: "残联服务工单",
                  },
                  component: () =>
                    import(
                      "@/views/callCenter/detailsInfo/canlianReturn/index"
                    ),
                  children: [
                    {
                      path: "/remnantOrder1",
                      name: "remnantOrder1",
                      mate: {
                        title: "残联工单派发",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/canlianReturn/remnantOrder1"
                        ),
                    },
                    {
                      path: "/remnantOrder2",
                      name: "remnantOrder2",
                      mate: {
                        title: "残联工单处理",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/canlianReturn/remnantOrder2"
                        ),
                    },
                    {
                      path: "/remnantOrder3",
                      name: "remnantOrder3",
                      mate: {
                        title: "残联工单回访",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/canlianReturn/remnantOrder3"
                        ),
                    },
                    {
                      path: "/remnantOrder4",
                      name: "remnantOrder4",
                      mate: {
                        title: "残联工单待作废",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/canlianReturn/remnantOrder4"
                        ),
                    },
                    {
                      path: "/remnantOrder5",
                      name: "remnantOrder5",
                      mate: {
                        title: "残联工单已完成",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/canlianReturn/remnantOrder5"
                        ),
                    },
                    {
                      path: "/remnantOrder6",
                      name: "remnantOrder6",
                      mate: {
                        title: "残联工单已作废",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/canlianReturn/remnantOrder6"
                        ),
                    },
                    {
                      path: "/remnantOrder7",
                      name: "remnantOrder7",
                      mate: {
                        title: "残联工单查询",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/canlianReturn/remnantOrder7"
                        ),
                    },
                  ],
                },
                {
                  path: "/busReturn",
                  name: "busReturn",
                  mate: {
                    title: "商业服务工单",
                  },
                  component: () =>
                    import(
                      "@/views/callCenter/detailsInfo/busReturn/index"
                    ),
                  children: [
                    {
                      path: "/busOrder1",
                      name: "busOrder1",
                      mate: {
                        title: "商业工单派发",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/busReturn/busOrder1"
                        ),
                    },
                    {
                      path: "/busOrder2",
                      name: "busOrder2",
                      mate: {
                        title: "商业工单处理",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/busReturn/busOrder2"
                        ),
                    },
                    {
                      path: "/busOrder3",
                      name: "busOrder3",
                      mate: {
                        title: "商业工单回访",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/busReturn/busOrder3"
                        ),
                    },
                    {
                      path: "/busOrder4",
                      name: "busOrder4",
                      mate: {
                        title: "商业工单待作废",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/busReturn/busOrder4"
                        ),
                    },
                    {
                      path: "/busOrder5",
                      name: "busOrder5",
                      mate: {
                        title: "商业工单已完成",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/busReturn/busOrder5"
                        ),
                    },
                    {
                      path: "/busOrder6",
                      name: "busOrder6",
                      mate: {
                        title: "商业工单已作废",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/busReturn/busOrder6"
                        ),
                    },
                    {
                      path: "/busOrder7",
                      name: "busOrder7",
                      mate: {
                        title: "商业工单查询",
                      },
                      component: () =>
                        import(
                          "@/views/callCenter/detailsInfo/busReturn/busOrder7"
                        ),
                    },
                  ],
                },
              ],
            },
            {
              path: "/updateInfo",
              name: "updateInfo",
              mate: {
                title: "话务统计",
              },
              component: () => import("@/views/callCenter/updateInfo/index"),

              children: [
                {
                  path: "/statistics",
                  name: "statistics",
                  mate: {
                    title: "话务统计",
                  },
                  component: () =>
                    import("@/views/callCenter/updateInfo/statistics"),
                },
                {
                  path: "/callInCount",
                  name: "callInCount",
                  mate: {
                    title: "呼入电话统计",
                  },
                  component: () =>
                    import("@/views/callCenter/updateInfo/callInCount"),
                },
                {
                  path: "/exhaleCount",
                  name: "exhaleCount",
                  mate: {
                    title: "呼出电话统计",
                  },
                  component: () =>
                    import("@/views/callCenter/updateInfo/exhaleCount"),
                },
                {
                  path: "/jinxian",
                  name: "jinxian",
                  mate: {
                    title: "进线分时段统计",
                  },
                  component: () =>
                    import("@/views/callCenter/updateInfo/jinxian"),
                },
              ],
            },
            {
              path: "/healthy",
              name: "healthy",
              mate: {
                title: "通话记录",
              },
              component: () => import("@/views/callCenter/healthy/index"),
            },
            {
              path: "/textMessage",
              name: "textMessage",
              mate: {
                title: "短信记录",
              },
              component: () => import("@/views/callCenter/textMessage/index"),
            },
            {
              path: "/textSend",
              name: "textSend",
              mate: {
                title: "短信发送",
              },
              component: () => import("@/views/callCenter/textSend/index"),
            },
            {
              path: "/settlementManage",
              name: "settlementManage",
              mate: {
                title: "工单结算管理",
              },
              component: () =>
                import("@/views/callCenter/settlementManage/index"),
            },
            {
              path: "/addWorkOrder",
              name: "addWorkOrder",
              mate: {
                title: "联络历史",
              },
              component: () => import("@/views/callCenter/addWorkOrder/index"),
            },
            {
              path: "/workapplicationManage",
              name: "workapplicationManage",
              mate: {
                title: "工单申请管理",
              },
              component: () =>
                import("@/views/callCenter/workapplicationManage/index"),
            },
            {
              path: "/liaison",
              name: "liaison",
              mate: {
                title: "漏接来电统计",
              },
              component: () => import("@/views/callCenter/liaison/index"),
            },
            {
              path: "/serviceRecord",
              name: "serviceRecord",
              mate: {
                title: "话务监管",
              },
              component: () => import("@/views/callCenter/serviceRecord/index"),
            },
            {
              path: "/locationInfo",
              name: "locationInfo",
              mate: {
                title: "话务小结",
              },
              component: () => import("@/views/callCenter/locationInfo/index"),
              redirect: "/operator",
              children: [
                {
                  path: "/operator",
                  name: "operator",
                  mate: {
                    title: "话务小结统计",
                  },
                  component: () =>
                    import("@/views/callCenter/locationInfo/operator"),
                },
              ],
            },

            {
              path: "/trajectoryInfo",
              name: "trajectoryInfo",
              mate: {
                title: "质检管理",
              },
              component: () =>
                import("@/views/callCenter/trajectoryInfo/index"),
              redirect: "/trajectoryMange",
              children: [
                {
                  path: "/trajectoryMange",
                  name: "trajectoryMange",
                  mate: {
                    title: "质检管理",
                  },
                  component: () =>
                    import("@/views/callCenter/trajectoryInfo/trajectoryMange"),
                },
                {
                  path: "/trajectorySell",
                  name: "trajectorySell",
                  mate: {
                    title: "质检派发",
                  },
                  component: () =>
                    import("@/views/callCenter/trajectoryInfo/trajectorySell"),
                },
                {
                  path: "/trajectoryVisit",
                  name: "trajectoryVisit",
                  mate: {
                    title: "质检回访",
                  },
                  component: () =>
                    import("@/views/callCenter/trajectoryInfo/trajectoryVisit"),
                },
              ],
            },
            // {
            // 	path: '/trajectoryInfo',
            // 	name: 'trajectoryInfo',
            // 	mate: {
            // 		title: '质检管理'
            // 	},
            // 	component: () => import("@/views/callCenter/trajectoryInfo/index")
            // },
            {
              path: "/electronics",
              name: "electronics",
              mate: {
                title: "老人管理",
              },
              component: () => import("@/views/callCenter/electronics/index"),
            },
            {
              path: "/bigScreen",
              name: "bigScreen",
              mate: {
                title: "大屏展示",
              },
              component: () => import("@/views/callCenter/bigScreen/index"),
            },
            {
              path: "/callPackageType",
              name: "callPackageType",
              mate: {
                title: "套餐类型",
              },
              component: () =>
                import("@/views/callCenter/callDictionary/callPackageType"),
            },
            {
              path: "/callServiceCategory",
              name: "callServiceCategory",
              mate: {
                title: "服务类别",
              },
              component: () =>
                import("@/views/callCenter/callDictionary/callServiceCategory"),
            },
            {
              path: "/equipmentType",
              name: "equipmentType",
              mate: {
                title: "设备类型",
              },
              component: () =>
                import("@/views/callCenter/callDictionary/equipmentType"),
            },
            {
              path: "/trafficOpen",
              name: "trafficOpen",
              mate: {
                title: "沟通类型",
              },
              component: () =>
                import("@/views/callCenter/callDictionary/trafficOpen"),
            },
            {
              path: "/todayTarget",
              name: "todayTarget",
              mate: {
                title: "今日目标",
              },
              component: () =>
                import("@/views/callCenter/callDictionary/todayTarget"),
            },
            {
              path: "/learnType",
              name: "learnType",
              mate: {
                title: "学习培训",
              },
              component: () =>
                import("@/views/callCenter/callDictionary/learnType"),
            },
            {
              path: "/callServiceItems",
              name: "callServiceItems",
              mate: {
                title: "服务项目",
              },
              component: () =>
                import("@/views/callCenter/callDictionary/callServiceItems"),
            },
            {
              path: "/serviceStaff",
              name: "serviceStaff",
              mate: {
                title: "服务人员",
              },
              component: () =>
                import("@/views/callCenter/detailsInfo/serviceStaff/index"),
            },
            {
              path: "/agentCcontrol",
              name: "agentCcontrol",
              mate: {
                title: "服务人员",
              },
              component: () =>
                import("@/views/callCenter/callDictionary/agentCcontrol"),
            },

            {
              path: "/orgBuild",
              name: "orgBuild",
              mate: {
                title: "",
              },
              component: () => import("@/views/elderlyService/orgBuild/index"),
              redirect: "/communityManage",
              children: [
                {
                  path: "/communityManage",
                  name: "communityManage",
                  mate: {
                    title: "社区管理",
                  },
                  component: () =>
                    import(
                      "@/views/elderlyService/orgBuild/communityManage/index"
                    ),
                },
                {
                  path: "/orgWork",
                  name: "orgWork",
                  mate: {
                    title: "组织工作",
                  },
                  component: () =>
                    import("@/views/elderlyService/orgBuild/orgWork/index"),
                },
              ],
            },
            {
              path: "/standardAddress",
              name: "standardAddress",
              mate: {
                title: "标准地址库",
              },
              component: () =>
                import("@/views/elderlyService/standardAddress/index"),
            },
            {
              path: "/serviceMange",
              name: "serviceMange",
              mate: {
                title: "机构管理",
              },
              component: () =>
                import("@/views/elderlyService/serviceMange/index"),
            },
            {
              path: "/taskSetting",
              name: "taskSetting",
              mate: {
                title: "任务设置",
              },
              component: () =>
                import("@/views/elderlyService/taskSetting/index"),
            },
            {
              path: "/joinMange",
              name: "joinMange",
              mate: {
                title: "加盟店管理",
              },
              component: () => import("@/views/elderlyService/joinMange/index"),
            },
            {
              path: "/serviceCapital",
              name: "serviceCapital",
              mate: {
                title: "服务资金库",
              },
              component: () =>
                import("@/views/elderlyService/serviceCapital/index"),
            },
            {
              path: "/divisionalManage",
              name: "divisionalManage",
              mate: {
                title: "部门管理",
              },
              component: () =>
                import(
                  "@/views/elderlyService/dataDictionary/divisionalManage.vue"
                ),
            },
            {
              path: "/personnelType1",
              name: "personnelType1",
              mate: {
                title: "人员类型",
              },
              component: () =>
                import(
                  "@/views/elderlyService/dataDictionary/personnelType.vue"
                ),
            },
            {
              path: "/serviceObject1",
              name: "serviceObject1",
              mate: {
                title: "老人类别",
              },
              component: () =>
                import(
                  "@/views/elderlyService/dataDictionary/serviceObject.vue"
                ),
            },
            {
              path: "/positionManage",
              name: "positionManage",
              mate: {
                title: "职位管理",
              },
              component: () =>
                import("@/views/elderlyService/dataDictionary/position.vue"),
            },
            {
              path: "/benefitOld",
              name: "benefitOld",
              mate: {
                title: "惠老政策",
              },
              component: () =>
                import("@/views/elderlyService/benefitMange/benefitOld/index"),
            },
            {
              path: "/newsInfo",
              name: "newsInfo",
              mate: {
                title: "新闻资讯",
              },
              component: () =>
                import("@/views/elderlyService/benefitMange/newsInfo/index"),
            },
            {
              path: "/notices",
              name: "notices",
              mate: {
                title: "通知公告",
              },
              component: () =>
                import("@/views/elderlyService/benefitMange/notices/index"),
            },
            {
              path: "/businessGuide",
              name: "businessGuide",
              mate: {
                title: "办事指南",
              },
              component: () =>
                import(
                  "@/views/elderlyService/benefitMange/businessGuide/index"
                ),
            },
            {
              path: "/homeMange",
              name: "homeMange",
              mate: {
                title: "居家养老管理",
              },
              component: () =>
                import("@/views/elderlyService/resource/homeMange/index"),
            },
            {
              path: "/productManages", //产品管理
              name: "productManages",
              component: () =>
                import("@/views/elderlyService/resource/productManage/index"),
              mate: {
                title: "产品管理",
              },
            },
            {
              path: "/monitors", //产品管理
              name: "monitors",
              component: () =>
                import("@/views/elderlyService/resource/monitors/index"),
              mate: {
                title: "监控管理",
              },
            },
            {
              path: "/mechanismMange",
              name: "mechanismMange",
              mate: {
                title: "机构养老管理",
              },
              component: () =>
                import("@/views/elderlyService/resource/mechanismMange/index"),
            },
            {
              path: "/communityMange",
              name: "communityMange",
              mate: {
                title: "社区养老管理",
              },
              component: () =>
                import("@/views/elderlyService/resource/communityMange/index"),
            },
            {
              path: "/olderMange",
              name: "olderMange",
              mate: {
                title: "服务对象",
              },
              component: () =>
                import("@/views/elderlyService/resource/olderMange/index"),
            },
            {
              path: "/servicePerson",
              name: "servicePerson",
              mate: {
                title: "服务人员",
              },
              component: () =>
                import("@/views/elderlyService/resource/servicePerson/index"),
            },
            {
              path: "/assessmentReports",
              name: "assessmentReports",
              mate: {
                title: "评估报告",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/assessmentReports/index"
                ),
            },
            {
              path: "/addressMange",
              name: "addressMange",
              mate: {
                title: "地址管理",
              },
              component: () =>
                import("@/views/elderlyService/resource/addressMange/index"),
            },
            {
              path: "/knowledgeMange",
              name: "knowledgeMange",
              mate: {
                title: "知识库管理",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/knowledge/knowledgeMange/index"
                ),
            },
            {
              path: "/businessInfo",
              name: "businessInfo",
              mate: {
                title: "业务资料库",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/knowledge/businessInfo/index"
                ),
            },
            {
              path: "/businessTypes",
              name: "businessTypes",
              mate: {
                title: "业务资料库类别",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/knowledge/businessTypes/index"
                ),
            },
            {
              path: "/questionLibrary",
              name: "questionLibrary",
              mate: {
                title: "问题库",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/knowledge/questionLibrary/index"
                ),
            },
            {
              path: "/indexImport",
              name: "indexImport",
              mate: {
                title: "首页大屏导入",
              },
              component: () =>
                import(
                  "@/views/dataImport/indexImport/index"
                ),
            },
            {
              path: "/disabledImport",
              name: "disabledImport",
              mate: {
                title: "残疾人之家大屏导入",
              },
              component: () =>
                import(
                  "@/views/dataImport/disabledImport/index"
                ),
            },
            {
              path: "/childCenterImport",
              name: "childCenterImport",
              mate: {
                title: "托养中心大屏导入",
              },
              component: () =>
                import(
                  "@/views/dataImport/childCenterImport/index"
                ),
            },
            {
              path: "/labourUnion",
              name: "labourUnion",
              mate: {
                title: "工会组织",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/organization/labourUnion/index"
                ),
            },
            {
              path: "/chamberCommerce",
              name: "chamberCommerce",
              mate: {
                title: "商会组织",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/organization/chamberCommerce/index"
                ),
            },
            {
              path: "/socialWorker",
              name: "socialWorker",
              mate: {
                title: "社工组织",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/organization/socialWorker/index"
                ),
            },
            {
              path: "/houseLogin",
              name: "houseLogin",
              mate: {
                title: "房屋信息登录",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/house/houseLogin/index"
                ),
            },
            {
              path: "/houseRent",
              name: "houseRent",
              mate: {
                title: "承租信息登记表",
              },
              component: () =>
                import("@/views/elderlyService/resource/house/houseRent/index"),
            },
            {
              path: "/publicSafe",
              name: "publicSafe",
              mate: {
                title: "公共安全",
              },
              component: () =>
                import("@/views/elderlyService/resource/land/publicSafe/index"),
            },
            {
              path: "/marketSupervision",
              name: "marketSupervision",
              mate: {
                title: "市场监管",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/marketSupervision/index"
                ),
            },
            {
              path: "/serviceMen",
              name: "serviceMen",
              mate: {
                title: "为民服务",
              },
              component: () =>
                import("@/views/elderlyService/resource/land/serviceMen/index"),
            },
            {
              path: "/guaranteeMen",
              name: "guaranteeMen",
              mate: {
                title: "民生保障",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/guaranteeMen/index"
                ),
            },
            {
              path: "/multiMediation",
              name: "multiMediation",
              mate: {
                title: "多元调解",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/multiMediation/index"
                ),
            },
            {
              path: "/marketCompany",
              name: "marketCompany",
              mate: {
                title: "市场企业",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/marketCompany/index"
                ),
            },
            {
              path: "/estateMange",
              name: "estateMange",
              mate: {
                title: "物业管理人员",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/team/estateMange/index"
                ),
            },
            {
              path: "/lawyer",
              name: "lawyer",
              mate: {
                title: "律师",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/team/lawyer/index"
                ),
            },
            {
              path: "/communityPolice",
              name: "communityPolice",
              mate: {
                title: "社区民警",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/team/communityPolice/index"
                ),
            },
            {
              path: "/hospital",
              name: "hospital",
              mate: {
                title: "医院",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/hygiene/hospital/index"
                ),
            },
            {
              path: "/pharmacy",
              name: "pharmacy",
              mate: {
                title: "药店",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/hygiene/pharmacy/index"
                ),
            },
            {
              path: "/clinic",
              name: "clinic",
              mate: {
                title: "诊所",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/hygiene/clinic/index"
                ),
            },
            {
              path: "/trainingInstitutions",
              name: "trainingInstitutions",
              mate: {
                title: "培训机构",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/education/trainingInstitutions/index"
                ),
            },
            {
              path: "/kindergarten",
              name: "kindergarten",
              mate: {
                title: "幼儿园",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/education/kindergarten/index"
                ),
            },
            {
              path: "/school",
              name: "school",
              mate: {
                title: "学校",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/education/school/index"
                ),
            },
            {
              path: "/realPopulation",
              name: "realPopulation",
              mate: {
                title: "实有人口",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/realPopulation/index"
                ),
            },
            {
              path: "/objectCare",
              name: "objectCare",
              mate: {
                title: "关怀对象",
              },
              component: () =>
                import("@/views/elderlyService/resource/men/objectCare/index"),
            },
            {
              path: "/epidemicPopulation",
              name: "epidemicPopulation",
              mate: {
                title: "疫情人口",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/epidemicPopulation/index"
                ),
            },
            {
              path: "/communityCorrection",
              name: "communityCorrection",
              mate: {
                title: "社区矫正人员",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/special/communityCorrection/index"
                ),
            },
            {
              path: "/keyPetition",
              name: "keyPetition",
              mate: {
                title: "重点上访",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/special/keyPetition/index"
                ),
            },
            {
              path: "/helpSettle",
              name: "helpSettle",
              mate: {
                title: "安置帮教",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/special/helpSettle/index"
                ),
            },
            {
              path: "/releasePrison",
              name: "releasePrison",
              mate: {
                title: "刑满释放人员",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/special/releasePrison/index"
                ),
            },
            {
              path: "/disciplineHealth",
              name: "disciplineHealth",
              mate: {
                title: "社戒社康人员",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/special/disciplineHealth/index"
                ),
            },
            {
              path: "/troubleOther",
              name: "troubleOther",
              mate: {
                title: "肇事肇祸等严重精神障碍患者",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/special/troubleOther/index"
                ),
            },

            {
              path: "/publicOpinion",
              name: "publicOpinion",
              mate: {
                title: "社情民意收集",
              },
              component: () =>
                import("@/views/elderlyService/social/publicOpinion/index"),
            },
            {
              path: "/wasteStation",
              name: "wasteStation",
              mate: {
                title: "废品站",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/marketSupervision/WasteStation/index.vue"
                ),
            },
            {
              path: "/supermarketConvenience",
              name: "supermarketConvenience",
              mate: {
                title: "超市 便利店",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/marketSupervision/supermarketConvenience/index.vue"
                ),
            },
            {
              path: "/foodMarket",
              name: "foodMarket",
              mate: {
                title: "菜市场",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/marketSupervision/foodMarket/index.vue"
                ),
            },
            {
              path: "/bank",
              name: "bank",
              mate: {
                title: "银行",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/marketSupervision/bank/index.vue"
                ),
            },
            {
              path: "/gasStation",
              name: "gasStation",
              mate: {
                title: "加油站",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/marketSupervision/gasStation/index.vue"
                ),
            },
            {
              path: "/policeStation",
              name: "policeStation",
              mate: {
                title: "派出所",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/publicSafe/policeStation/index.vue"
                ),
            },
            {
              path: "/policeRoom",
              name: "policeRoom",
              mate: {
                title: "警务室",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/publicSafe/policeRoom/index.vue"
                ),
            },
            {
              path: "/redProperty",
              name: "redProperty",
              mate: {
                title: "红色物业",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/serviceMen/redProperty/index.vue"
                ),
            },
            {
              path: "/residentsCouncil",
              name: "residentsCouncil",
              mate: {
                title: "居民议事会",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/serviceMen/residentsCouncil/index.vue"
                ),
            },
            {
              path: "/partyMassMeeting",
              name: "partyMassMeeting",
              mate: {
                title: "党群议事会",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/serviceMen/partyMassMeeting/index.vue"
                ),
            },
            {
              path: "/PartyMassActivityAenter",
              name: "PartyMassActivityAenter",
              mate: {
                title: "党群活动中心",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/serviceMen/PartyMassActivityAenter/index.vue"
                ),
            },
            {
              path: "/enterpriseProperty",
              name: "enterpriseProperty",
              mate: {
                title: "企业型物业",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/serviceMen/enterpriseProperty/index.vue"
                ),
            },
            {
              path: "/judicialOffice",
              name: "judicialOffice",
              mate: {
                title: "法律服务所",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/multiMediation/judicialOffice/index.vue"
                ),
            },
            {
              path: "/LawOffices",
              name: "LawOffices",
              mate: {
                title: "司法所",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/multiMediation/LawOffice/index.vue"
                ),
            },
            {
              path: "/MediationCommittee",
              name: "MediationCommittee",
              mate: {
                title: "调解委员会",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/multiMediation/MediationCommittee/index.vue"
                ),
            },
            {
              path: "/MarketEnterprises",
              name: "MarketEnterprises",
              mate: {
                title: "市场企业",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/marketCompany/MarketEnterprises/index.vue"
                ),
            },
            {
              path: "/AlongTheStreetFront",
              name: "AlongTheStreetFront",
              mate: {
                title: "沿街门面",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/marketCompany/AlongTheStreetFront/index.vue"
                ),
            },
            {
              path: "/BuildingEnterprises",
              name: "BuildingEnterprises",
              mate: {
                title: "楼宇企业",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/land/marketCompany/BuildingEnterprises/index.vue"
                ),
            },
            {
              path: "/floatingPopulation",
              name: "floatingPopulation",
              mate: {
                title: "流动人口",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/realPopulation/floatingPopulation/index.vue"
                ),
            },
            {
              path: "/BasicInformationOfPopulation",
              name: "BasicInformationOfPopulation",
              mate: {
                title: "人口基础信息表",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/realPopulation/BasicInformationOfPopulation/index.vue"
                ),
            },
            {
              path: "/theElderlys",
              name: "theElderlys",
              mate: {
                title: "80岁以上老人",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/objectCare/theElderly/index.vue"
                ),
            },
            {
              path: "/Disabled",
              name: "Disabled",
              mate: {
                title: "残疾人",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/objectCare/Disabled/index.vue"
                ),
            },
            {
              path: "/EmptyNester",
              name: "EmptyNester",
              mate: {
                title: "空巢老人",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/objectCare/EmptyNester/index.vue"
                ),
            },
            {
              path: "/FamilyPlanningPersonnel",
              name: "FamilyPlanningPersonnel",
              mate: {
                title: "计生人员",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/objectCare/FamilyPlanningPersonnel/index.vue"
                ),
            },
            {
              path: "/PregnantWomen",
              name: "PregnantWomen",
              mate: {
                title: "孕优对象",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/objectCare/PregnantWomen/index.vue"
                ),
            },
            {
              path: "/leftbehindChildren",
              name: "leftbehindChildren",
              mate: {
                title: "留守儿童",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/objectCare/leftbehindChildren/index.vue"
                ),
            },
            {
              path: "/onelyOldPeople",
              name: "lonelyOldPeople",
              mate: {
                title: "孤寡老人(70岁以上)",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/objectCare/lonelyOldPeople/index.vue"
                ),
            },
            {
              path: "/DoubleSupportObject",
              name: "DoubleSupportObject",
              mate: {
                title: "双拥对象",
              },
              component: () =>
                import(
                  "@/views/elderlyService/resource/men/objectCare/DoubleSupportObject/index.vue"
                ),
            },
            {
              path: "/organizationIndex",
              name: "organizationIndex",
              meta: {
                index: 511,
              },
              component: () =>
                import("./views/system/organization/organizationIndex.vue"),
            },
            // 按组织授权
            {
              path: "/assignOrganization",
              name: "assignOrganization",
              meta: {
                index: 512,
              },
              component: () =>
                import("./views/system/assign/assignOrganization.vue"),
            },
            {
              path: "/assignRole",
              name: "assignRole",
              meta: {
                index: 512,
              },
              component: () => import("./views/system/assign/assignRole.vue"),
            },
            //菜单管理
            {
              path: "/rightIndex",
              name: "rightIndex",
              meta: {
                index: 531,
              },
              component: () => import("./views/system/right/rightIndex.vue"),
            },
            {
              path: "/roleIndex",
              name: "roleIndex",
              meta: {
                index: 521,
              },
              component: () => import("./views/system/role/roleIndex.vue"),
            },
            //职位管理
            {
              path: "/positionManagement",
              name: "positionManagement",
              meta: {
                index: 531,
              },
              component: () => import("./views/system/positionManagement.vue"),
            },
            // 按角色授权
            // {
            //     path: '/roleRight',
            //     name: 'roleRight',
            //     meta: {
            //         index: 522
            //     },
            //     component: () =>
            //         import ('./views/system/role/roleRight.vue'),
            // },
            {
              path: "/onlineIndex",
              name: "onlineIndex",
              meta: {
                index: 541,
              },
              component: () => import("./views/system/online/onlineIndex.vue"),
            },
            {
              path: '/deviceManage',
              name: 'deviceManage',
              meta: {
                index: 580
              },
              component: () =>
                import('./views/device/deviceManage/index.vue'),
            },
            {
              path: '/deviceBind',
              name: 'deviceBind',
              meta: {
                index: 581
              },
              component: () =>
                import('./views/device/deviceBind/index.vue'),
            },
            {
              path: '/deviceInfo',
              name: 'deviceInfo',
              meta: {
                index: 582
              },
              component: () =>
                import('./views/device/deviceInfo/index.vue'),
            },
            {
              path: "/userIndex",
              name: "userIndex",
              meta: {
                index: 551,
              },
              component: () => import("./views/system/user/userIndex.vue"),
            },
            {
              path: "/userLog",
              name: "userLog",
              meta: {
                index: 552,
              },
              component: () => import("./views/system/user/userLog.vue"),
            },
            {
              path: "/AddressManagement",
              name: "AddressManagement",
              meta: {
                index: 553,
              },
              component: () => import("./views/system/AddressManagement.vue"),
            },
            // {
            //     path: "/productManage", //产品管理
            //     name: "productManage",
            //     component: () =>
            //         import ("./views/system/productManage.vue"),
            //     mate: {
            //         title: '产品管理'
            //     }
            // },
            {
              path: "/dictionaries", //数字字典
              name: "dictionaries",
              component: () => import("./views/system/dictionaries"),
              mate: {
                title: "字典",
              },
            },

            {
              path: "/addressLibrary", //标准地址库
              name: "addressLibrary",
              component: () => import("./views/system/addressLibrary"),
              mate: {
                title: "标准地址库",
              },
            },
            {
              path: "/streetManage", //jiedao管理
              name: "streetManage",
              component: () => import("./views/system/streetManage"),
              mate: {
                title: "街道管理",
              },
            },
            //  字典管理
            {
              path: "/dicIndex",
              name: "dicIndex",
              meta: {
                index: 561,
              },
              component: () => import("./views/system/dic/dicIndex.vue"),
            },
            //  字典数据 /:dictId(\\d+)
            {
              path: "/dicData/:dictId",
              name: "dicData",
              meta: {
                index: 561,
              },
              component: () => import("./views/system/dic/data.vue"),
            },
          ],
        },
      ],
    },

    // 新登录页
    {
      path: "/login",
      name: "login",
      meta: {
        index: 0,
      },
      component: () =>
        import("./views/login.vue") /* webpackChunkName: "about" */,
    },
    {
      path: "/homeindex",
      name: "homeindex",
      meta: {
        index: 1,
      },
      component: () =>
        import("./views/homeindex.vue") /* webpackChunkName: "about" */,
    },

    {
      path: "/",
      redirect: "/login",
    },

    //
    // 社区治理old
    {
      path: "/governmentAffairs",
      name: "governmentAffairs",
      meta: {
        index: 21,
      },
      component: () =>
        import("./views/governmentAffairs.vue") /* webpackChunkName: "about" */,
    },

    // 社区治理-网格管理
    {
      path: "/Gridding",
      name: "Gridding",
      redirect: "",
      meta: {
        index: 211,
      },
      component: () => import("./views/governmentAffairschildren/Gridding.vue"),
      /* webpackChunkName: "about" */
      children: [
        //社区治理人员管理系统
        {
          path: "/personnelManagementSystem",
          name: "personnelManagementSystem",
          meta: {
            index: 2113,
          },
          component: () =>
            import(
              "./views/governmentAffairschildren/gridding/personnelManagementSystem.vue"
            ) /* webpackChunkName: "about" */,
        },
        {
          path: "/griddingList",
          name: "griddingList",
          meta: {
            index: 211,
          },
          redirect: "/videoMonitor",
          component: () =>
            import("./views/governmentAffairschildren/griddingList.vue"),
          /* webpackChunkName: "about" */
          children: [
            // 社区环保
            {
              path: "/videoMonitor",
              name: "videoMonitor",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/videoMonitor.vue"
                ) /* webpackChunkName: "about" */,
            },
          ],
        },
      ],
    },

    // {
    //   path: '/dataCentreindex2',
    //   name: 'dataCentreindex2',
    //   meta: { index: 542 },
    //   component: () => import('./views/governmentAffairschildren/dataCentre/dataCentreindextest.vue'),
    // },

    // 总头

    {
      path: "/commonHeader",
      name: "commonHeader",
      meta: {
        index: 211,
      },
      component: () =>
        import("./views/governmentAffairschildren/commonHeader.vue"),
      /* webpackChunkName: "about" */
      children: [
        //新首页
        {
          path: "/newIndex",
          name: "newIndex",
          meta: {
            index: 4,
          },
          component: () => import("./views/platform/newIndex.vue"),
          redirect: "/newIindex",
          children: [
            //便民服务首页
            {
              path: "/newIindex",
              name: "newIindex",
              meta: {
                index: 331,
              },
              component: () =>
                import("./views/platform/newIndex/newIindex.vue"),
            },
          ],
        },

        //智慧政务
        {
          path: "/zhengwu",
          name: "zhengwu",
          meta: {
            index: 21,
          },
          component: () =>
            import("./views/governmentAffairschildren/zhengwu.vue"),
          redirect: "/zhzw",
          children: [
            {
              path: "/zhzw",
              name: "zhzw",
              meta: {
                index: 2111,
              },
              component: () =>
                import("./views/governmentAffairschildren/zhzw/zhzw.vue"),
            },
            {
              path: "/oneStopProcessingTemplate",
              name: "oneStopProcessingTemplate",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/zhzw/oneStopProcessingTemplate.vue"
                ),
            },
            {
              path: "/oneStopProcessing",
              name: "oneStopProcessing",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/zhzw/oneStopProcessing.vue"
                ),
            },
            {
              path: "/oneStopProcessingConsult",
              name: "oneStopProcessingConsult",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/zhzw/oneStopProcessingConsult.vue"
                ),
            },
            {
              path: "/oneStopProcessingProve",
              name: "oneStopProcessingProve",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/zhzw/oneStopProcessingProve.vue"
                ),
            },
            {
              path: "/mzjz",
              name: "mzjz",
              meta: {
                index: 331,
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/mzjz.vue"),
            },
            {
              path: "/tyjrsw",
              name: "tyjrsw",
              meta: {
                index: 331,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/policyInfo/tyjrsw.vue"
                ),
            },
            {
              path: "/rsbz",
              name: "rsbz",
              meta: {
                index: 331,
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/rsbz.vue"),
            },
            {
              path: "/cjrbz",
              name: "cjrbz",
              meta: {
                index: 331,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/policyInfo/cjrbz.vue"
                ),
            },
            {
              path: "/wsjk",
              name: "wsjk",
              meta: {
                index: 331,
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/wsjk.vue"),
            },
            {
              path: "/gzfsq",
              name: "gzfsq",
              meta: {
                index: 331,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/policyInfo/gzfsq.vue"
                ),
            },
            {
              path: "/sqjs",
              name: "sqjs",
              meta: {
                index: 331,
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/sqjs.vue"),
            },
            // {
            //   path: '/onlineSms',
            //   name: 'onlineSms',
            //   meta: {
            //     index: 542
            //   },
            //   component: () => import('./views/system/online/onlineSms.vue'),
            // },
            //   //  短信发送
            //   {
            //     path: '/onlineSmsSend',
            //     name: 'onlineSmsSend',
            //     meta: {
            //       index: 542
            //     },
            //     component: () => import('./views/system/online/onlineSmsSend.vue'),
            //   },
            //   //  短信模板
            //   {
            //     path: '/smsTemplate',
            //     name: 'smsTemplate',
            //     meta: {
            //       index: 542
            //     },
            //     component: () => import('./views/system/online/smsTemplate.vue'),
            //   },
          ],
        },
        // z智慧养老一张图
        {
          path: "/provideImage",
          name: "provideImage",
          component: () =>
            import("./views/platform/provideManage/provideImage.vue"),
        },
        // 智慧养老
        {
          path: "/provideManage",
          name: "provideManage",
          meta: {
            index: 33,
          },
          component: () => import("./views/platform/provideManage.vue"),
          redirect: "/oldManFile",
          children: [
            {
              path: "/oldManFile",
              name: "oldManFile",
              component: () =>
                import("./views/platform/provideManage/oldManFile.vue"),
            },

            {
              path: "/addOldManFile",
              name: "addOldManFile",
              component: () =>
                import("./views/platform/provideManage/addOldManFile.vue"),
            },
            {
              path: "/serveProject",
              name: "serveProject",
              component: () =>
                import("./views/platform/provideManage/serveProject.vue"),
            },
            {
              path: "/serveCompany",
              name: "serveCompany",
              component: () =>
                import("./views/platform/provideManage/serveCompany.vue"),
            },
            {
              path: "/serveCompanyDetail",
              name: "serveCompanyDetail",
              component: () =>
                import("./views/platform/provideManage/serveCompanyDetail.vue"),
            },
            {
              path: "/serveWorkOrder",
              name: "serveWorkOrder",
              component: () =>
                import("./views/platform/provideManage/serveWorkOrder.vue"),
            },

            {
              path: "/provideOrganization",
              name: "provideOrganization",
              component: () =>
                import(
                  "./views/platform/provideManage/provideOrganization.vue"
                ),
            },
            {
              path: "/provideOrganizationInfo",
              name: "provideOrganizationInfo",
              component: () =>
                import(
                  "./views/platform/provideManage/provideOrganizationInfo.vue"
                ),
            },
            {
              path: "/provideMap",
              name: "provideMap",
              component: () =>
                import("./views/platform/provideManage/provideMap.vue"),
            },

            {
              path: "/provideHeKangServeObject",
              name: "provideHeKangServeObject",
              component: () =>
                import(
                  "./views/platform/provideManage/provideHeKangServeObject.vue"
                ),
            },
            {
              path: "/provideHeKangWorkOrder",
              name: "provideHeKangWorkOrder",
              component: () =>
                import(
                  "./views/platform/provideManage/provideHeKangWorkOrder.vue"
                ),
            },
            {
              path: "/provideHeKangServePeople",
              name: "provideHeKangServePeople",
              component: () =>
                import(
                  "./views/platform/provideManage/provideHeKangServePeople.vue"
                ),
            },

            {
              path: "/provideCommunity",
              name: "provideCommunity",
              component: () =>
                import("./views/platform/provideManage/provideCommunity.vue"),
            },
            {
              path: "/provideCommunityInfo",
              name: "provideCommunityInfo",
              component: () =>
                import(
                  "./views/platform/provideManage/provideCommunityInfo.vue"
                ),
            },
            {
              path: "/communityMap",
              name: "communityMap",
              component: () =>
                import("./views/platform/provideManage/communityMap.vue"),
            },
            {
              path: "/serveReturn",
              name: "serveReturn",
              component: () =>
                import("./views/platform/provideManage/serveReturn.vue"),
            },
            // {
            //     path: '/oldManStatistics',
            //     name: 'oldManStatistics',
            //     component: () =>
            //         import ('./views/platform/provideManage/oldManStatistics.vue')
            // },
            {
              path: "/workOrderStatistics",
              name: "workOrderStatistics",
              component: () =>
                import(
                  "./views/platform/provideManage/workOrderStatistics.vue"
                ),
            },
            {
              path: "/organizationStatistics",
              name: "organizationStatistics",
              component: () =>
                import(
                  "./views/platform/provideManage/organizationStatistics.vue"
                ),
            },
            {
              path: "/consultManage",
              name: "consultManage",
              component: () =>
                import("./views/platform/provideManage/consultManage.vue"),
            },

            // {
            //     path: '/provideImage',
            //     name: 'provideImage',
            //     component: () => import('./views/platform/provideManage/provideImage.vue')
            // },
            {
              path: "/assistHelpRecord",
              name: "assistHelpRecord",
              component: () =>
                import("./views/platform/provideManage/assistHelpRecord.vue"),
            },
            {
              path: "/servePeople",
              name: "servePeople",
              component: () =>
                import("./views/platform/provideManage/servePeople.vue"),
            },
            {
              path: "/serveBack",
              name: "serveBack",
              component: () =>
                import("./views/platform/provideManage/serveBack.vue"),
            },
          ],
        },
        // 智慧协商
        {
          path: "/communityConsultation",
          name: "communityConsultation",
          meta: {
            index: 33,
          },
          component: () => import("./views/platform/communityConsultation.vue"),
          redirect: "/communityConsultation",
          children: [
            {
              path: "/communityConsultation",
              name: "communityConsultation",
              component: () =>
                import("./views/platform/gridding/communityConsultation.vue"),
            },
            {
              path: "/communityIssueTitle",
              name: "communityIssueTitle",
              component: () =>
                import("./views/platform/gridding/communityIssueTitle.vue"),
            },
            {
              path: "/communitylssueUp",
              name: "communitylssueUp",
              component: () =>
                import("./views/platform/gridding/communitylssueUp.vue"),
            },
            {
              path: "/communitySqOrganization",
              name: "communitySqOrganization",
              component: () =>
                import("./views/platform/gridding/communitySqOrganization.vue"),
            },
            {
              path: "/PartyOrganizationManagement",
              name: "PartyOrganizationManagement",
              component: () =>
                import(
                  "./views/platform/gridding/PartyOrganizationManagement.vue"
                ),
            },
            {
              path: "/regularWork",
              name: "regularWork",
              component: () =>
                import("./views/platform/gridding/regularWork.vue"),
            },
            {
              path: "/communityWgOrganization",
              name: "communityWgOrganization",
              component: () =>
                import("./views/platform/gridding/communityWgOrganization.vue"),
            },
            {
              path: "/communityIssuePerson",
              name: "communityIssuePerson",
              component: () =>
                import("./views/platform/gridding/communityIssuePerson.vue"),
            },
            {
              path: "/communityIssueArea",
              name: "communityIssueArea",
              component: () =>
                import("./views/platform/gridding/communityIssueArea.vue"),
            },
            {
              path: "/communityIssueFg",
              name: "communityIssueFg",
              component: () =>
                import("./views/platform/gridding/communityIssueFg.vue"),
            },
            {
              path: "/communityIssueCPerson",
              name: "communityIssueCPerson",
              component: () =>
                import("./views/platform/gridding/communityIssueCPerson.vue"),
            },
            {
              path: "/communityIssueType",
              name: "communityIssueType",
              component: () =>
                import("./views/platform/gridding/communityIssueType.vue"),
            },
            {
              path: "/communityWgPerson",
              name: "communityWgPerson",
              component: () =>
                import("./views/platform/gridding/communityWgPerson.vue"),
            },
            {
              path: "/communitySqPerson",
              name: "communitySqPerson",
              component: () =>
                import("./views/platform/gridding/communitySqPerson.vue"),
            },
          ],
        },
        //智慧治理
        {
          path: "/community",
          name: "community",
          meta: {
            index: 542,
          },
          component: () =>
            import("./views/governmentAffairschildren/community.vue"),
          children: [
            {
              path: "/griddingindex",
              name: "griddingindex",
              meta: {
                index: 542,
              },
              //component: () => import('./views/governmentAffairschildren/gridding/griddingindex.vue'),
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/gridsidebar.vue"
                ),
            },
            {
              path: "/danganguanli",
              name: "danganguanli",
              meta: {
                index: 542,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/danganguanli"
                ),
            },
            {
              path: "/regularWork",
              name: "regularWork",
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/regularWork"
                ),
            },
            {
              path: "/shehuizuzhi",
              name: "shehuizuzhi",
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/shehuizuzhi"
                ),
            },
            {
              path: "/shehuigongzuozhe",
              name: "shehuigongzuozhe",
              meta: {
                index: 542,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/shehuigongzuozhe"
                ),
            },
            {
              path: "/zhengcexinxi",
              name: "zhengcexinxi",
              meta: {
                index: 542,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/zhengcexinxi"
                ),
            },
            {
              path: "/banli",
              name: "banli",
              meta: {
                index: 542,
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/banli"),
            },
            {
              path: "/manageType",
              name: "manageType",
              meta: {
                index: 542,
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/manageType"),
            },
            {
              path: "/smartInform",
              name: "smartInform",
              component: () =>
                import(
                  "./views/governmentAffairschildren/smart/smartInform.vue"
                ),
            },
            {
              path: "/smartsl",
              name: "smartsl",
              component: () =>
                import("./views/governmentAffairschildren/smart/smartsl.vue"),
            },
            // 活动列表
            {
              path: "/twoNetworkConvergenceActivity",
              name: "twoNetworkConvergenceActivity",
              meta: {
                index: 337,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/smart/twoNetworkConvergenceActivity.vue"
                ),
            },
            //考勤管理 考勤地图
            {
              path: "/attendanceMap",
              name: "attendanceMap",
              component: () =>
                import("./views/platform/gridding/attendanceMap.vue"),
            },
            //考勤管理 考勤列表
            {
              path: "/attendanceList",
              name: "attendanceList",
              component: () =>
                import("./views/platform/gridding/attendanceList.vue"),
            },
            //考勤管理 考勤时间设置
            {
              path: "/attendanceTime",
              name: "attendanceTime",
              component: () =>
                import("./views/platform/gridding/attendanceTime.vue"),
            },
            // 考勤管理
            //考勤管理 申请管理 请假管理
            {
              path: "/leaveManagement",
              name: "leaveManagement",
              component: () =>
                import("./views/platform/gridding/leaveManagement.vue"),
            },
            //考勤管理 申请管理 加班管理
            {
              path: "/overtimeManagement",
              name: "overtimeManagement",
              component: () =>
                import("./views/platform/gridding/overtimeManagement.vue"),
            },
            //考勤管理 申请管理 补卡申请
            {
              path: "/cardReplacementApplication",
              name: "cardReplacementApplication",
              component: () =>
                import(
                  "./views/platform/gridding/cardReplacementApplication.vue"
                ),
            },
            //考勤管理 申请管理 换班
            {
              path: "/shiftChange",
              name: "shiftChange",
              component: () =>
                import("./views/platform/gridding/shiftChange.vue"),
            },
            //考勤管理 申请管理 外出
            {
              path: "/goOut",
              name: "goOut",
              component: () => import("./views/platform/gridding/goOut.vue"),
            },
            // 网格任务
            {
              path: "/gridTask",
              name: "gridTask",
              component: () => import("./views/platform/gridding/gridTask.vue"),
            },
            // 网格日志
            {
              path: "/graddingLog",
              name: "graddingLog",
              component: () =>
                import(
                  "./views/governmentAffairschildren/smart/graddingLog.vue"
                ),
            },
            //投诉与建议
            {
              path: "/communityComplaintAdvice",
              name: "communityComplaintAdvice",
              meta: {
                index: 331,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/communityComplaintAdvice.vue"
                ),
            },
            // 基础信息库 特殊人群 学龄人群
            {
              path: "/gridsidebar1",
              name: "gridsidebar1",
              meta: {
                index: 2112,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/gridsidebar.vue"
                ) /* webpackChunkName: "about" */,
            },
            {
              path: "/gridsidebar2",
              name: "gridsidebar2",
              meta: {
                index: 2112,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/gridsidebar.vue"
                ) /* webpackChunkName: "about" */,
            },
            {
              path: "/gridsidebar3",
              name: "gridsidebar3",
              meta: {
                index: 2112,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/gridsidebar.vue"
                ) /* webpackChunkName: "about" */,
            },
            {
              path: "/gridsidebar4",
              name: "gridsidebar4",
              meta: {
                index: 2112,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/gridsidebar.vue"
                ) /* webpackChunkName: "about" */,
            },
            // 网格工作 网格巡查
            {
              path: "/networkPatrolRw",
              name: "networkPatrolRw",
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/networkPatrolRw.vue"
                ),
            },
            {
              path: "/networkPatrolLx",
              name: "networkPatrolLx",
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/networkPatrolLx.vue"
                ),
            },
            {
              path: "/networkPatrolFp",
              name: "networkPatrolFp",
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/networkPatrolFp.vue"
                ),
            },
            {
              path: "/networkPatrolJd",
              name: "networkPatrolJd",
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/networkPatrolJd.vue"
                ),
            },
            {
              path: "/networkPatrolJl",
              name: "networkPatrolJl",
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/networkPatrolJl.vue"
                ),
            },
            {
              path: "/networkPatrolJdPerson",
              name: "networkPatrolJdPerson",
              meta: {
                index: 4,
                title: "person",
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/networkPatrolJdPerson.vue"
                ),
            },
            {
              path: "/networkPatrolJlPerson",
              name: "networkPatrolJlPerson",
              meta: {
                index: 4,
                title: "person",
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/gridding/networkPatrolJlPerson.vue"
                ),
            },
          ],
        },
        //文明创建
        {
          path: "/civilization",
          name: "civilization",
          meta: {
            index: 21,
          },
          component: () =>
            import("./views/civilizationCreation/civilization.vue"),
          redirect: "/articleManagement",
          children: [
            {
              path: "/articleManagement",
              name: "articleManagement",
              component: () =>
                import("./views/civilizationCreation/articleManagement.vue"),
            },
            {
              path: "/albumManagement",
              name: "albumManagement",
              component: () =>
                import("./views/civilizationCreation/albumManagement.vue"),
            },
            {
              path: "/civilizedVolunteers",
              name: "civilizedVolunteers",
              component: () =>
                import("./views/civilizationCreation/civilizedVolunteers.vue"),
            },
            {
              path: "/commentManagement",
              name: "commentManagement",
              component: () =>
                import("./views/civilizationCreation/commentManagement.vue"),
            },
            {
              path: "/columnManagement",
              name: "columnManagement",
              component: () =>
                import("./views/civilizationCreation/columnManagement.vue"),
            },
            {
              path: "/siteManagement",
              name: "siteManagement",
              component: () =>
                import("./views/civilizationCreation/siteManagement.vue"),
            },
            {
              path: "/unitInformationMaintenance",
              name: "unitInformationMaintenance",
              component: () =>
                import(
                  "./views/civilizationCreation/unitInformationMaintenance.vue"
                ),
            },
            {
              path: "/userManagement",
              name: "userManagement",
              component: () =>
                import("./views/civilizationCreation/userManagement.vue"),
            },
            {
              path: "/systemNotification",
              name: "systemNotification",
              component: () =>
                import("./views/civilizationCreation/systemNotification.vue"),
            },
          ],
        },
        //智慧平安
        {
          path: "/pingan",
          name: "pingan",
          meta: {
            index: 21,
          },
          component: () =>
            import("./views/governmentAffairschildren/pingan.vue"),
          redirect: "/theGridManagement",
          children: [
            {
              path: "/theGridManagement",
              name: "theGridManagement",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/theGridManagement/theGridManagement.vue"
                ),
            },
            {
              path: "/publicSafety",
              name: "publicSafety",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/theGridManagement/publicSafety.vue"
                ),
            },
            {
              path: "/renYuanXinXi",
              name: "renYuanXinXi",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/theGridManagement/renYuanXinXi.vue"
                ),
            },
            {
              path: "/faceMonitor",
              name: "faceMonitor",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/theGridManagement/faceMonitor.vue"
                ),
            },
            {
              path: "/faceMonitor2",
              name: "faceMonitor2",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/theGridManagement/faceMonitor2.vue"
                ),
            },
            {
              path: "/faceMonitor3",
              name: "faceMonitor3",
              meta: {
                index: 2111,
              },
              component: () =>
                import(
                  "./views/governmentAffairschildren/theGridManagement/faceMonitor3.vue"
                ),
            },
          ],
        },
        //大数据平台
        {
          path: "/dataCentreindex",
          name: "dataCentreindex",
          meta: {
            index: 542,
          },
          component: () =>
            import(
              "./views/governmentAffairschildren/dataCentre/dataCentreindex.vue"
            ),
        },
        {
          path: "/dataCentreindex2",
          name: "dataCentreindex2",
          meta: {
            index: 542,
          },
          component: () =>
            import("./views/governmentAffairschildren/dataCentre/dangjian.vue"),
        },

        //物业服务
        {
          path: "/wuye",
          name: "wuye",
          meta: {
            index: 2114,
          },
          component: () =>
            import("./views/governmentAffairschildren/wuyefuwu.vue"),
          redirect: "/wyDisputeType",
          children: [
            {
              path: "/wyDisputeType",
              name: "wyDisputeType",
              component: () =>
                import(
                  "./views/governmentAffairschildren/propertyService/wyDisputeType.vue"
                ),
            },
            {
              path: "/wyProblemSell",
              name: "wyProblemSell",
              component: () =>
                import(
                  "./views/governmentAffairschildren/propertyService/wyProblemSell.vue"
                ),
            },
            {
              path: "/wyPropertys",
              name: "wyPropertys",
              component: () =>
                import(
                  "./views/governmentAffairschildren/propertyService/wyPropertys.vue"
                ),
            },
          ],
        },
        //投诉与建议
        {
          path: "/communityComplaintAdvice",
          name: "communityComplaintAdvice",
          meta: {
            index: 331,
          },
          component: () =>
            import(
              "./views/governmentAffairschildren/communityComplaintAdvice.vue"
            ),
        },
        //政策信息
        {
          path: "/policyInfo",
          name: "policyInfo",
          meta: {
            index: 331,
          },
          component: () =>
            import("./views/governmentAffairschildren/policyInfo.vue"),
        },
        //办事指南
        {
          path: "/businessGuide",
          name: "businessGuide",
          meta: {
            index: 2114,
          },
          component: () =>
            import("./views/governmentAffairschildren/businessGuide.vue"),
          redirect: "/businessGuideIndex",
          children: [
            {
              path: "/businessGuideIndex",
              name: "businessGuideIndex",
              component: () =>
                import(
                  "./views/governmentAffairschildren/businessGuide/businessGuideIndex.vue"
                ),
            },
            {
              path: "/businessGuideList",
              name: "businessGuideList",
              component: () =>
                import(
                  "./views/governmentAffairschildren/businessGuide/businessGuideList.vue"
                ),
            },
            {
              path: "/businessGuideType",
              name: "businessGuideType",
              component: () =>
                import(
                  "./views/governmentAffairschildren/businessGuide/businessGuideType.vue"
                ),
            },
            {
              path: "/oneStopProcessing",
              name: "oneStopProcessing",
              component: () =>
                import(
                  "./views/governmentAffairschildren/businessGuide/oneStopProcessing.vue"
                ),
            },
            {
              path: "/oneStopProcessingTemplate",
              name: "oneStopProcessingTemplate",
              component: () =>
                import(
                  "./views/governmentAffairschildren/businessGuide/oneStopProcessingTemplate.vue"
                ),
            },
            {
              path: "/oneStopProcessingProve",
              name: "oneStopProcessingProve",
              component: () =>
                import(
                  "./views/governmentAffairschildren/businessGuide/oneStopProcessingProve.vue"
                ),
            },
            {
              path: "/oneStopProcessingConsult",
              name: "oneStopProcessingConsult",
              component: () =>
                import(
                  "./views/governmentAffairschildren/businessGuide/oneStopProcessingConsult.vue"
                ),
            },
          ],
        },
      ],
    },
    {
      path: "/hekang",
      name: "hekang",
      meta: {
        index: 1,
      },
      component: () =>
        import("./views/hekang.vue") /* webpackChunkName: "about" */,
    },

  ],
})

router.beforeEach((to, from, next) => {
  const isAuth = sessionStorage.getItem("tokens")
    ? sessionStorage.getItem("tokens")
    : ""
  if (to.path !== "/login" && isAuth == "") {
    next({ path: "/login" })
  } else {
    next()
  }
})
export default router
